<template>
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
    <Header/>
    <!-- <router-view> -->
    <router-view v-slot="{ Component, route }">
  <keep-alive :include="['ProductListing']">
    <component :is="Component" :key="route.fullPath" />
  </keep-alive>
</router-view>
    <Footer/>
</template>
<script>
import Header from '@/components/prelogin/Header.vue';
// import Header from '@/components/prelogin/Header-new.vue';
import Footer from '@/components/prelogin/Footer.vue';

import '@/assets/common/css/bootstrap-3-styles.css' 
import '@/assets/common/css/bootstrap-select.min.css'
import '@/assets/common/css/wqa.css'
import '@/assets/common/css/styles.css'
import '@/assets/common/css/font-awesome.min.css'
export default{
    name:'prelogin-layout',
    components:{
        Header,
        Footer
    }
    }
</script>